module.exports = __webpack_public_path__ + "static/img/start.783c9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/GulpOfWater/start.jpg
// module id = zgsq
// module chunks = 1